import { html } from 'lit';

export default html`<div part="icon">
    <slot name="icon">
        <div aria-hidden="true" class="theoplayer-loading-progress">
            <div class="theoplayer-loading-spinner">
                <div class="theoplayer-loading-circle-clipper theoplayer-loading-circle-left">
                    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="24" r="18" fill="none" stroke-dasharray="113.097" stroke-dashoffset="56.549" stroke-width="4" />
                    </svg>
                </div>
                <div class="theoplayer-loading-gap-patch">
                    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="24" r="18" fill="none" stroke-dasharray="113.097" stroke-dashoffset="56.549" stroke-width="3.2" />
                    </svg>
                </div>
                <div class="theoplayer-loading-circle-clipper theoplayer-loading-circle-right">
                    <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="24" cy="24" r="18" fill="none" stroke-dasharray="113.097" stroke-dashoffset="56.549" stroke-width="4" />
                    </svg>
                </div>
            </div>
        </div>
    </slot>
</div>`;
